<script>
import { mapState, mapActions } from 'vuex';
import tabStrip from '@/mixins/tabstrip';
import { componentMap, components } from './componentMap';

export default {
  name: 'MainView',
  components: {
    ...components,
  },
  mixins: [tabStrip],
  data() {
    return {
      previousPath: '',
    };
  },
  computed: {
    ...mapState('mainView', ['tabs']),
    currentRoutePath() {
      return this.$route.path;
    },
  },
  watch: {
    $route(to, from) {
      this.previousPath = from.fullPath;
      this.handleRoute(to);
    },
  },
  mounted() {
    this.handleRoute(this.$route);
  },
  methods: {
    ...mapActions('mainView', ['removeAllTabs', 'closeNonActiveTabs']),
    getTabComponent(action) {
      return componentMap[action];
    },
    handleRoute(to) {
      const { action } = to.params;
      const component = this.getTabComponent(action);

      if (component) {
        const hasTab = this.tabs.find(t => t.path === to.fullPath);
        if (hasTab) {
          this.$router.push(to.fullPath);
        } else {
          this.addNewTab({ action, title: component.title, path: to.fullPath });
        }
      }
    },
    destroyTab($event, index) {
      $event.preventDefault();
      $event.stopPropagation();

      this.closeTab(index);
    },
    closeAllTabs() {
      this.$router.push('/dashboard');
      this.removeAllTabs();
    },
    closeInactiveTabs() {
      this.closeNonActiveTabs(this.currentRoutePath);
    },
  },
};
</script>

<template>
  <div class="main-view">
    <v-tabs height="40"
            slider-color="#26a73a"
            color="white"
            show-arrows>

      <v-tab v-for="(tab, i) in tabs"
             :key="i"
             ripple
             exact
             :to="tab.path"
             class="tab-item">

        <span>{{ tab.title }}</span>

        <button class="tab-destroy-button"
                @click="destroyTab($event, i)">
          <v-icon>close</v-icon>
        </button>

      </v-tab>

      <v-menu
        v-if="tabs.length"
        :close-on-content-click="true"
        nudge-right="10"
        nudge-bottom="5"
        bottom left
        :menu-props="{ offsetY: true }"
      >
        <template slot="activator">
          <v-btn class="white tab-settings pa-1" depressed>
            <v-icon small>more_horiz</v-icon>
          </v-btn>
        </template>

        <v-list dense>
          <v-list-tile @click="closeInactiveTabs">
            <v-list-tile-title>Alle schließen, außer aktive</v-list-tile-title>
          </v-list-tile>

          <v-list-tile @click="closeAllTabs">
            <v-list-tile-title>Alle Tabs schließen</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>

      <v-tab-item v-for="(tab) in tabs"
                  :key="tab.path"
                  :id="tab.path">
        <component :is="getTabComponent(tab.action).component"
                   :path="tab.path"
                   :context="tab" />
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<style lang="scss">
.main-view {
  height: 90vh;
  overflow-y: scroll;
}

.tab-item {
  .v-tabs__item {
    padding: 0 !important;

    span {
      flex: 1;
      padding: 0 10px;
      text-decoration: none;
      color: black;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .tab-destroy-button {
    border: 0;
    margin: 0 3px;
    height: 100%;
    width: 20px;
    outline: none;

    i {
      font-size: 16px;
    }
  }
}

.tab-settings {
  border: 1px solid #ddd !important;
  border-bottom: 2px solid #26a73a !important;
  height: 33px;
  margin: 7px 2px 2px 0;
  border-radius: 4px 4px 0 0;
}
</style>
